import type { AppFormType } from 'app/developer-v3/types';

export const hasMissingRequiredIntegrationSettings = (
  integrationSettings: AppFormType
) => {
  const {
    app_category: category = '',
    description = '',
    intention = '',
    role = '',
    title = '',
  } = integrationSettings;

  return !category || !description || !intention || !role || !title;
};
